import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MobileBottomNav, MobileTopBar, Sidebar } from "./Navbar";
import AddJobModal from "./AddJobModal";
import Toasts from "./Toasts";
import EmptyState from "./EmptyState";
import { useApp } from "../context/AppContext";

function Content() {
  const { status, loadError, reload } = useApp();

  if (status === "loading") {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading your jobs…</span>
        </div>
      </div>
    );
  }
  if (status === "error") {
    return (
      <div className="card mt-4">
        <EmptyState
          icon="bi-wifi-off"
          title="Couldn't load your data"
          text={loadError}
          action={
            <button className="btn btn-primary btn-sm" onClick={reload}>
              Try again
            </button>
          }
        />
      </div>
    );
  }
  return <Outlet />;
}

function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="app-main">
        <MobileTopBar />
        <main className="app-content">
          <Content />
        </main>
      </div>
      <MobileBottomNav />
      <AddJobModal />
      <Toasts />
    </div>
  );
}

export default Layout;
